import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { MainStore } from 'src/app/common/main.store';
import { UserService } from 'src/app/services/user.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventType, AuthenticationResult, EventMessage, InteractionStatus } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  private readonly _destroying$ = new Subject<void>();

  constructor(
      private store: MainStore,
      private userService: UserService,
      private router: Router,
      private authService: AuthService,
      private msalService: MsalService, 
      private msalBroadcastService: MsalBroadcastService,
      private cdref: ChangeDetectorRef
    ) { }

    async ngOnInit(): Promise<void>{
      this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>  msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
      )
      .subscribe(async (result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(payload.account);        
      });        

      this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(async () => {
        let activeAccount = this.msalService.instance.getActiveAccount();

        if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
          let accounts = this.msalService.instance.getAllAccounts();
          this.msalService.instance.setActiveAccount(accounts[0]);  
        }
        
        this.router.navigate(['home']);
      })
    }

    ngOnDestroy(): void {
      this._destroying$.next(undefined);
      this._destroying$.complete();
    }
  
  }
